import React from 'react'
import Banner from '../../components/banner/Banner'
import Gallery from '../../components/gallery/Gallery'
import './main.css'

const Main = () => {

      return (
            <div className="main_content">
                  <Banner /> 
                  <Gallery />
            </div>
      )
}

export default Main
